module.exports = __webpack_public_path__ + "assets/start.5d750cc3.svg";